<template lang="pug">
v-container(fluid)
    v-card.pa-2.ma-2.mx-0(:class="cardClass" @click="onDayMenuClick")
        v-row(cols="12" no-gutters)
            v-col.text-capitalize {{ offerItem.dayName }}
            v-col.text-right {{ offerItem.displayDate }}
        v-row(no-gutters v-if="!setFreeDay")
            v-col(cols="12" v-for="(menuGroupItem, idx) in offerItem.menuGroupList" :key="idx")
                CalendarGroupKindItem.mt-2(
                    :menuGroupItem="menuGroupItem" :offerItem="offerItem" :reservationItem="getReservationItem(menuGroupItem)"
                )
        v-row(no-gutters v-else)
          v-col
            CalendarGroupKindItem( :eventName="getEventName" )

</template>

<script lang="ts">
import Vue from 'vue'

import DailyMenuOfferOrder from '@/model/dailymenu/DailyMenuOfferOrder'
import CalendarGroupKindItem from '@/components/boarder-detail-dialog/CalendarGroupKindItem.vue'
import MenuReservationItem from '@/model/dailymenu/MenuReservationItem'
import moment from 'moment'
import {Component, Prop} from "vue-property-decorator";
import CalendarEventForDay from "@/model/calendar/CalendarEventForDay";
import {GET_CALENDAR_EVENTS} from "@/store/getter-types";


@Component({
  components: {
    CalendarGroupKindItem
  }
})
export default class CalendarOfferItem extends Vue{

  @Prop({ type: Object as () => DailyMenuOfferOrder, required: true }) offerItem!: DailyMenuOfferOrder
  @Prop({ type: Date }) date!: Date
  @Prop({ type: Array as () => MenuReservationItem[] }) reservationItem!: MenuReservationItem[]

  private events: CalendarEventForDay[] | undefined = undefined
  private setFreeDay: boolean = false


  get cardClass (): string | undefined {
    if (this.date) {
      if (moment(this.offerItem.date).isSame(this.date, 'date')) {
        return 'grey lighten-3'
      }
    }

    return undefined
   }

  getCurrentEvent(): void {
    if (this.events) {
      const foundEvent: CalendarEventForDay | undefined = this.events.find((item: CalendarEventForDay) => moment(item.date).format('DD.M.YYYY') == moment(this.offerItem.formatedDbDate).format('DD.M.YYYY'))
      this.setFreeDay = !!foundEvent
    }
  }

  getReservationItem (menuGroupItem: any): any | null {
    const foundReservationItem: MenuReservationItem | undefined = this.reservationItem.find((item: MenuReservationItem) =>  item.topMenuGroup.id === menuGroupItem.id)
    return foundReservationItem ? foundReservationItem : null
  }

  get getEventName(): string{
    const foundEvent: CalendarEventForDay | undefined = this.events!.find((item: CalendarEventForDay) => moment(item.date).format('DD.M.YYYY') == moment(this.offerItem.formatedDbDate).format('DD.M.YYYY'))
    if (foundEvent!.kind.name == 'holiday') {
      return 'Prázdniny'
    } else if(foundEvent!.kind.name == 'free_day') {
      return 'Voľný deň'
    } else {
      return ''
    }
  }


    onDayMenuClick (): void {
      this.$emit('onChangeDate', this.offerItem.formatedDbDate)
    }

    mounted(): void {
      this.events = this.$store.getters[GET_CALENDAR_EVENTS]

      this.getCurrentEvent()
    }

}
</script>

<style lang="stylus" scoped>

</style>
